module.exports = __webpack_public_path__ + "static/desc.b88dd70b.png";